import { render, staticRenderFns } from "./EditFeature.vue?vue&type=template&id=b8d41f32&"
import script from "./EditFeature.vue?vue&type=script&lang=js&"
export * from "./EditFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports